export const AVALIACOES_ATENDIMENTOS_API_URL = process.env.REACT_APP_AVALIACOES_ATENDIMENTOS_API_URL
export const ATENDIMENTOS_API_URL = process.env.REACT_APP_ATENDIMENTOS_API_URL
export const CONTEUDO_API_URL = process.env.REACT_APP_CONTEUDO_API_URL
